import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';

interface IProps {
	settingsId: string;
	onChange: (value: string) => void;
}

export const FullNameField: React.FC<IProps> = ({ settingsId, onChange }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterCardholdersFullName') }], [t]);

	return (
		<FormInput
			testId="FullNameField"
			name={`fullName-${settingsId}`}
			label="cardholdersFullNameLabel"
			onChange={onChange}
			validationRules={validationRules}
		/>
	);
};
